import { render, staticRenderFns } from "./MessageRecipientPopover.vue?vue&type=template&id=8f630808&scoped=true&"
import script from "./MessageRecipientPopover.vue?vue&type=script&lang=js&"
export * from "./MessageRecipientPopover.vue?vue&type=script&lang=js&"
import style0 from "./MessageRecipientPopover.vue?vue&type=style&index=0&id=8f630808&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f630808",
  null
  
)

export default component.exports